import React from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import infoContent from "../data/infoContent.json";
import { useSeo } from "../lib/seo";
import { DeleteAccountForm } from "../components/DeleteAccountForm";

const ORDER = ["about", "contacts", "delivery", "returns", "delete-account"];

export default function InfoPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const page = infoContent.pages[slug];
  const goBack = () => (location.key === "default" ? navigate("/app/home") : navigate(-1));

  useSeo({
    title: page ? page.title : "Информация — ANGIOLINI",
    description: page ? page.description : undefined,
    canonical: page ? `/info/${slug}` : undefined,
    noindex: !page,
  });

  if (!page) {
    return (
      <div data-testid="info-not-found" style={{ minHeight: "100vh", background: "var(--ang-bg)", color: "var(--ang-text)",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 14, padding: 24 }}>
        <h1 style={{ fontFamily: "Italiana", fontSize: 28 }}>Страница не найдена</h1>
        <Link to="/app/catalog" style={{ color: "var(--ang-gold-strong)", fontFamily: "Manrope", fontSize: 14 }}>
          Перейти в каталог
        </Link>
      </div>
    );
  }

  return (
    <div data-testid={`info-page-${slug}`} style={{ minHeight: "100vh", background: "var(--ang-bg)", color: "var(--ang-text)" }}>
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "20px 20px 60px" }}>
        <button onClick={goBack} data-testid="info-back"
          style={{ display: "flex", alignItems: "center", gap: 6, background: "transparent", border: "none",
            color: "var(--ang-text)", opacity: 0.7, fontFamily: "Manrope", fontSize: 13, cursor: "pointer", padding: 0 }}>
          <ChevronLeft size={16} /> Назад
        </button>

        <h1 style={{ fontFamily: "Italiana", fontSize: "clamp(26px, 5vw, 40px)", margin: "22px 0 8px", lineHeight: 1.15 }}>
          {page.h1}
        </h1>

        {page.blocks.map(([heading, text]) => (
          <section key={heading} style={{ marginTop: 26 }}>
            <h2 style={{ fontFamily: "Manrope", fontSize: 15, fontWeight: 700, letterSpacing: "0.04em",
              textTransform: "uppercase", color: "var(--ang-text)", opacity: 0.75, margin: "0 0 8px" }}>
              {heading}
            </h2>
            <p style={{ fontFamily: "Manrope", fontSize: 14, lineHeight: 1.7, margin: 0, opacity: 0.9 }}>{text}</p>
          </section>
        ))}

        {slug === "delete-account" && <DeleteAccountForm />}

        <nav style={{ marginTop: 40, display: "flex", flexWrap: "wrap", gap: 14 }}>
          {ORDER.filter(s => s !== slug).map(s => (
            <Link key={s} to={`/info/${s}`} data-testid={`info-link-${s}`}
              style={{ fontFamily: "Manrope", fontSize: 13, color: "var(--ang-gold-strong)" }}>
              {infoContent.pages[s].h1}
            </Link>
          ))}
          <Link to="/app/catalog" data-testid="info-link-catalog"
            style={{ fontFamily: "Manrope", fontSize: 13, color: "var(--ang-gold-strong)" }}>
            Каталог
          </Link>
        </nav>
      </div>
    </div>
  );
}
